import React, {useCallback, useContext, useRef, useState} from "react";
import {
  AAccordion,
  AAccordionBody,
  AAccordionHeader,
  AAccordionHeaderTitle,
  AAccordionPanel,
  AButton,
  AIcon
} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {isEmpty} from "lodash-es";
import {useSelector} from "react-redux";
import {RelationsGraphContext} from "contexts/RelationsGraphContext";
import {selectInvestigationGraphLoading} from "store/selectors/investigationSelectors";
import GraphTimebar from "./GraphTimebar";
import css from "./TimebarAccordion.module.scss";

const TimebarAccordion = () => {
  const timebarRef = useRef();

  const isLoading = useSelector(selectInvestigationGraphLoading);

  const {timebarModel} = useContext(RelationsGraphContext);

  const [timebarCollapsed, setTimebarCollapsed] = useState(false);

  const resetTimebar = useCallback(
    (e) => {
      e.stopPropagation();
      timebarRef.current.reset();
    },
    [timebarRef]
  );

  return (
    <AAccordion
      className={classNames(css.accordion, "my-0")}
      data-testid={"InvestigationDetail-TimebarAccordion"}>
      <AAccordionPanel
        className={css.panel}
        collapsed={timebarCollapsed}
        onToggle={(panelKey) => setTimebarCollapsed(panelKey)}>
        <AAccordionHeader className={css.header}>
          <AAccordionHeaderTitle
            chevron={true}
            className={classNames(
              css.title,
              "d-flex align-center justify-space-between"
            )}>
            <AButton
              title="Reset Time Range"
              secondary
              medium
              onClick={resetTimebar}
              disabled={isLoading || isEmpty(timebarModel)}>
              <AIcon>refresh</AIcon>
            </AButton>
          </AAccordionHeaderTitle>
        </AAccordionHeader>
        <AAccordionBody className="ma-0 pa-0">
          <GraphTimebar ref={timebarRef} />
        </AAccordionBody>
      </AAccordionPanel>
    </AAccordion>
  );
};

export default TimebarAccordion;
